module.exports = "\n<div class=\"wrapper\">\n    <div class=\"sidebar\" data-color=\"purple\" data-image=\"\">\n        <sidebar-cmp></sidebar-cmp>\n        <div class=\"sidebar-background\" style=\"background-image: url(assets/img/cityscape.png)\"></div>\n    </div>\n    <div class=\"main-panel\">\n        <navbar-cmp></navbar-cmp>\n        <router-outlet></router-outlet>\n        <footer-cmp></footer-cmp>\n    </div>\n\n</div>\n<!-- <fixedplugin-cmp></fixedplugin-cmp> -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/layouts/auth/auth.component.html
// module id = ../../../../../src/app/layouts/auth/auth.component.html
// module chunks = 5